<template>
  <div class="success_form">
    <Message severity="success">
      <span class="notice"
        ><b>{{ $t("common.success.notice") }}:</b></span
      >
      <ul>
        <li
          class="list-group-item"
          v-for="succes in success"
          v-bind:key="succes"
        >
          <span>{{ succes }}</span>
        </li>
      </ul>
    </Message>
  </div>
</template>


<script>
export default {
  name: "Success",
  props: ["success"],
};
</script>


<style lang="scss" scoped>
</style>